<template>
    <InviteCandidateGraph :inviteData="listData" :userData="userList" :start="startDate"
    :end="endDate" v-if="listDataStatus" />
</template>
<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import InviteCandidateGraph from '../Overview/InviteCandidateGraph.vue'

export default {
    components: {
        InviteCandidateGraph
    },
    data() {
        return {
            listData: [],
            userList: [],
            startDate: '2025-01-01',
            endDate: '2025-01-31',
            listDataStatus:false,

        };
    },
    methods:{
        ...mapActions(['GetInvitationAnalysis','GetOverviewDashboard',"GetTestClientUserAnalysis"]),
        formatDate(date) {
            return moment(date).format("DD MMM YYYY (ddd)");
        },
        formatApiDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        async OverallDetails() {

            var date = moment(String(this.endDate)).add(1, 'days');
            var endDate = this.formatApiDate(date);
            var data = await this.GetOverviewDashboard({
                ClientId: this.user.clientId,
                startDate: this.startDate,
                endDate: endDate,
                mode: "Group"
            });
            this.basicDetails = data.object.data;
        },
        async inviteDetails() {
            var date = moment(String(this.endDate)).add(1, 'days');
            var endDate = this.formatApiDate(date);
            var data = await this.GetInvitationAnalysis({
                clientId: this.user.clientId,
                FromDate: this.startDate,
                ToDate: endDate
            });

            var user = await this.GetTestClientUserAnalysis({
                clientId: this.user.clientId,
                TestId: 0,
                RegionId: 0,
                FromDate: this.startDate,
                ToDate: endDate
            });
            if (user.status) {
                this.userList = user.object.data.inviteUseSumarries;
            }
            if (data.status) {
                this.listData = data.object.data;
                this.listDataStatus = this.listData.invitation_Model.publicInvite > 0 || this.listData.invitation_Model.privateInvite > 0;
            }                

        },
        async selectedCustomTime() {
            const date = new Date();
            if (this.startDate >= this.endDate) {
                return this.ShowWarningMessage("From Date can't be greater than To Date");
            }
            else if (this.startDate > date || this.endDate > date) {
                return this.ShowWarningMessage("Date can't be greater than Current Date");
            }
            this.PropStatus = false;
            await this.OverallDetails();
            await this.inviteDetails();
            this.PropStatus = true;
        },
    },
    async created() {
        this.selectedCustomTime();
    }, 
    computed:{
        ...mapState({
            user: (state) => state.auth.user,
        }),
    }
}

</script>